import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionTextArea from '../../../../presentation/EditSectionTextArea';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';

class LeadGenSettings extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      row: props.row === undefined ? {} : props.row,
      routingTypes: [],
      programs: []
    };

    this.onRoutingTypeChanged = this.onRoutingTypeChanged.bind( this );
    this.onDefDNISChanged = this.onDefDNISChanged.bind( this );
    this.onProgramNameChanged = this.onProgramNameChanged.bind( this );
    this.onDescriptionChanged = this.onDescriptionChanged.bind( this );
    this.onCheckNetChanged = this.onCheckNetChanged.bind( this );
    this.onControlRulesApplyChanged = this.onControlRulesApplyChanged.bind( this );
    this.onActiveChanged = this.onActiveChanged.bind( this );

    this.getData = this.getData.bind( this );
  }

  componentDidMount( ) {
    this.getData();
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( this.title, e.statusText , 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  onRoutingTypeChanged( e ) {
    let row = this.state.row;
    row.ROUTING_TYPE_ID = e.target.value;
    this.setState( { 
      row: row  
    }, this.onRowChanged( row ), this.getData() );
  }

  onDefDNISChanged( e ) {
    let row = this.state.row;
    row.DEFDNIS = e.target.value;
    row.PROGRAM_NAME = this.getProgramNameByPDNIS( e.target.value );
    this.setState( {
      row: row
    }, this.onRowChanged( row ) );
  }

  onProgramNameChanged( e ) { 
    let row = this.state.row;
    row.DEFDNIS = e.target.value;
    row.PROGRAM_NAME = this.getProgramNameByPDNIS( e.target.value );
    this.setState( { 
      row: row,
    }, this.onRowChanged( row ) );
  }

  onDescriptionChanged( e ) {
    let row = this.state.row;
    row.DESCRIPTION = e.target.value;
    this.setState( { 
      row: row
    }, this.onRowChanged( row ) );
  }

  onCheckNetChanged( e ) {
    let row = this.state.row;
 
    const CheckNetOptions = {
      NONE: 0,
      ON_NET: 1,
      OFF_NET: 2
    };

    const CHECK_NET = parseInt( e.target.value, 10 );  
    if( CHECK_NET === CheckNetOptions.NONE ) {
      row.CHK_ON = 0;
      row.CHK_OFF = 0;
    } else if( CHECK_NET === CheckNetOptions.ON_NET ) {
      row.CHK_ON = 1;
      row.CHK_OFF = 0;
    } else if( CHECK_NET === CheckNetOptions.OFF_NET ) {
      row.CHK_ON = 0;
      row.CHK_OFF = 1;
    } else /* Unknown options always default to use neither */ {
      row.CHK_ON = 0;
      row.CHK_OFF = 0;
    }
    this.setState( { 
      row: row
    }, this.onRowChanged( row ) );
  } 
  
  onControlRulesApplyChanged( e ) {
    let row = this.state.row;
    row.CONTROL_RULES_APPLY = parseInt( e.target.value, 10 );
    row.CONTROL_RULES_APPLY_TEXT = parseInt( e.target.value, 10 ) === 0 ? 'No' : 'Yes';
    this.setState( { 
      row: row
    }, this.onRowChanged( row ) );
  }

  onActiveChanged( e ) { 
    let row = this.state.row;
    row.ACTIVE = parseInt( e.target.value, 10 );
    row.ACTIVE_TEXT = parseInt( e.target.value, 10 ) === 0 ? 'No' : 'Yes';
    this.setState( { 
      row: row
    }, this.onRowChanged( row ) );
  }

  onRowChanged( row ) {
    if( this.props.onRowChanged !== undefined ) {
      this.props.onRowChanged( row );
    }
  }

  getProgramNameByPDNIS( PDNIS ) {
    const row = this.state.row;
    const programs = this.state.programs;
    if( programs !== undefined ) {
      for( var index = 0; index < programs.length; index++ ) {
        const program = programs[ index ];
        if( program.PDNIS === PDNIS ) {
          return program.PROGRAM_NAME;
        }
      }
    }
    return row.PROGRAM_NAME;
  }

  getData() {
    const getRoutingTypes = () => new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/routingtype' );
      api.get().then( ( data ) => {
        resolve( data );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );

    const getDefDnisList = ( row ) => new Promise ( ( resolve, reject ) => { 
      const api = new EtelAPI( 'leadgen/defdnislist' );
      const paramaters = [
        { ROUTING_TYPE_ID: row.ROUTING_TYPE_ID }
      ];
      api.get( paramaters ).then( ( data ) => {
        resolve( data );  
      } ).catch( ( exception ) => { 
        reject( exception );
      } );
    } );

    const handleException = ( exception ) => { 
      this.onHandleException( exception );
    };
    const ROUTING_TYPES_INDEX = 0;
    const PROGRAMS_INDEX = 1;
    const all = () => Promise.all( [
      getRoutingTypes(),
      getDefDnisList( this.state.row ) ]
    ).then( ( data ) => { 
      this.setState( { 
        routingTypes: data[ ROUTING_TYPES_INDEX ],
        ROUTING_TYPE_ID: data[ ROUTING_TYPES_INDEX ].ROUTING_TYPE_ID,
        programs: data[ PROGRAMS_INDEX ]
      } );
    } ).catch( ( exception ) => { 
      handleException( exception );
    } );
    all();
  }

  getProgramTypeOptions() { 
    const data = this.state.routingTypes;
    const options = [];
    data.map( ( item ) => { 
      options.push( { 'id': item.ROUTING_TYPE_ID, 'text': item.PROGRAM_TYPE } );
      return item;
    } );
    return options;
  }

  geDefDNISOptions( ) {
    const row = this.state.row;
    const data = this.state.programs;
    const options = [];
    let hasPDNIS = false;
    data.map( ( item ) => { 
      if( item.DEFDNIS === row.PDNIS ) {
        hasPDNIS = true;
      }
      options.push( { 'id': item.PDNIS, 'text': item.PDNIS } );
      return item;
    } );
    
    if( hasPDNIS === false ) {
      options.unshift( { 'id': row.DEFDNIS, 'text': row.DEFDNIS } );
    }    

    return options;
  }

  getProgramNameOptions( ) {
    const row = this.state.row;
    const data = this.state.programs;
    const options = [];
    let hasProgramName = false;
    data.map( ( item ) => { 
      if( item.PROGRAM_NAME === row.PROGRAM_NAME ) {
        hasProgramName = true;
      }
      options.push( { 'id': item.PDNIS, 'text': item.PROGRAM_NAME } );
      return item;
    } );

    if( hasProgramName === false ) {
      options.unshift( { 'id': row.DEFDNIS, 'text': row.PROGRAM_NAME } );
    }

    return options;  
  }

  render( ) {
    const row = this.state.row;
    const programTypeOptions = this.getProgramTypeOptions();
    const defDnisOptions = this.geDefDNISOptions();
    const programNameOptions = this.getProgramNameOptions();
    
    const checkNetOptions = [
      { 'id': 0, 'text':'None' },
      { 'id': 1, 'text':'On Net List' },
      { 'id': 2, 'text':'Off Net List' }
    ];

    let checkNet = 0;
    const CHK_ON = row.CHK_ON;
    const CHK_OFF = row.CHK_OFF;
    if( CHK_ON === 1 && CHK_OFF === 0 ) {
      checkNet = 1; // Uses an On Net List
    } else if( CHK_ON === 0 && CHK_OFF === 1 ) {
      checkNet = 2; // Uses an Off Net List
    } else {
      checkNet = 0; // Uses Neither On/Off Net List
    }
    
    let activeOptions = [
      { 'id': 0, 'text':'Not Active' },
      { 'id': 1, 'text':'Active' }
    ];

    let controlRulesApply = row.CONTROL_RULES_APPLY;
    let controlRulesApplyOptions= [
      { 'id': 0, 'text':'No' },
      { 'id': 1, 'text':'Yes' }
    ];

    return (
      <span className="leadgen-settings">
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="GROUP NAME"/>  
          <EditSectionLabel Text={row.GROUP_NAME} hilite />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="ROUTING TYPE" />  
          <EditSectionDropdown column={'ROUTING_TYPE_ID'} value={row.ROUTING_TYPE_ID} options={programTypeOptions} width="250px" onChanged={this.onRoutingTypeChanged} />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="DEFDNIS" />  
          <EditSectionDropdown column={'DEFDNIS'} value={row.DEFDNIS} options={defDnisOptions} width="250px" onChanged={this.onDefDNISChanged} />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="PROGRAM NAME" />  
          <EditSectionDropdown column={'PROGRAM_NAME'} value={row.DEFDNIS} options={programNameOptions} width="250px" />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="DESCRIPTION" />  
          <EditSectionTextArea column={'DESCRIPTION'} value={row.DESCRIPTION} width="250px" onChanged={this.onDescriptionChanged} placeholder="Enter Leadgen Description" />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="ON/OFF NET" />  
          <EditSectionDropdown column={'CHECK_NET'} value={checkNet} options={checkNetOptions} width="250px" onChanged={this.onCheckNetChanged} />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="BEGIN DATE" />  
          <EditSectionLabel Text={row.BEGINDATE} width="250px" hilite />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="END DATE" />  
          <EditSectionLabel Text={row.ENDDATE} width="250px" hilite />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="Control Group" />  
          <EditSectionDropdown column={'CONTROL_RULES_APPLY'} value={controlRulesApply} options={controlRulesApplyOptions} width="250px" onChanged={this.onControlRulesApplyChanged} />
        </span>
        <span className="leadgen-settings-field">
          <EditSectionLabel Text="ACTIVE" />  
          <EditSectionDropdown column={'ACTIVE'} value={row.ACTIVE} options={activeOptions} width="250px" onChanged={this.onActiveChanged} />
        </span>
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( LeadGenSettings ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/leadgen/components/LeadGenSettings.js